import React from "react"
import styles from "./navigation.module.scss"
import socials from "../../images/socials.svg"
import closeIcon from "../../images/navbar/close.svg"
import Markdown from "react-markdown"
import MailIcon from "../../images/navbar/mail.svg"
import PhoneIcon from "../../images/navbar/phone.svg"
import { Link, useStaticQuery } from "gatsby"

const query = graphql`
  query NavigationQuery {
    strapiGlobal {
      Address
      email
      logo {
        publicURL
      }
    }
  }
`
const Navigation = props => {
  const data = useStaticQuery(query)
  return (
    <div className={styles.navigation}>
      <div className={styles.navigation__top}>
        <Link to="/">
          <img
            src={data.strapiGlobal.logo.publicURL}
            className={styles.navigation__top__logo}
          />
        </Link>
        <img
          src={closeIcon}
          className={styles.navigation__top__close}
          onClick={props.close}
        />
      </div>
      <div className={styles.navigation__content__wrap}>
        <div className={styles.navigation__content}>
          <div className={styles.navigation__content__links}>
            <Link to="/" className={styles.navigation__content__links__link}>
              Home
            </Link>
            <Link
              to="/about"
              className={styles.navigation__content__links__link}>
              About Us
            </Link>
            <Link
              to="/services"
              className={styles.navigation__content__links__link}>
              Services
            </Link>
            <Link
              to="/case-studies"
              className={styles.navigation__content__links__link}>
              Case Studies
            </Link>
            <Link
              to="/logo-lounge"
              className={styles.navigation__content__links__link}>
              Logo Lounge
            </Link>
            <Link
              to="/contact"
              className={styles.navigation__content__links__link}>
              Contact
            </Link>
          </div>
        </div>
        <div className={styles.navigation__content__details}>
          <Markdown source={data.strapiGlobal.Address}></Markdown>
          <a href="tel:01163183771">+44 (0) 116 3183771</a>
          <a href={`mailto:${data.strapiGlobal.email}`}>
            {data.strapiGlobal.email}
          </a>
          <div className={styles.navigation__content__details__contacts}>
            <a href="tel:01163183771">
              <img src={PhoneIcon} alt="Phone" />
            </a>
            <a href={`mailto:` + props.email}>
              <img src={MailIcon} alt="Mail" />
            </a>
          </div>
          <Link to="/contact">
            <button>Start your project</button>
          </Link>
        </div>
      </div>
      <div className={styles.navigation__socials}>
        <img src={socials} />
      </div>
    </div>
  )
}

export default Navigation
